import { IPassengerInfo } from "../../dto";
import { DragTypeEnum } from "../../enums";
import { IRidePassengerRowBase, TDragRideDataProcessing } from "../../models";

export const generateDragIdKanbanPassenger = (
  rideId: number,
  passengerId: number,
): string => {
  return DragTypeEnum.KANBAN_PASSENGER + "_" + rideId + "_" + passengerId;
};

export const generateDragIdGridPassenger = (
  rideId: number,
  passengerId: number,
): string => {
  return DragTypeEnum.GRID_PASSENGER + "_" + rideId + "_" + passengerId;
};

export const generateDragIdGridRow = (rideId: number): string => {
  return DragTypeEnum.GRID_RIDE + "_" + rideId;
};

export const generateDropIdKanbanItem = (rideId: number): string => {
  return DragTypeEnum.KANBAN_RIDE + "_" + rideId;
};

export const generateDropIdGridItem = (rideId: number): string => {
  return DragTypeEnum.GRID_RIDE + "_" + rideId;
};

export const generateDragIdKanbanItem = (rideId: number): string => {
  return DragTypeEnum.KANBAN_RIDE + "_" + rideId;
};

export const generateDropIdCardBoardItem = (rideId: number): string => {
  return DragTypeEnum.CARD_BOARD_RIDE + "_" + rideId;
};

export const generateDragIdCardBoardItem = (rideId: number): string => {
  return DragTypeEnum.CARD_BOARD_RIDE + "_" + rideId;
};

export const combineDragPassengers = (
  passengerRowProps: IRidePassengerRowBase,
): IPassengerInfo[] => {
  const { rideDto, dragSelectedIds } = passengerRowProps;
  const passengerInfos = [passengerRowProps.passenger];

  if (dragSelectedIds?.length) {
    const idsExcludeCurrent = dragSelectedIds.filter(
      x => x !== passengerRowProps.passenger.id,
    );

    for (const passId of idsExcludeCurrent) {
      const pass = rideDto?.metadata?.passengersInfo?.find(
        x => x.id === passId,
      );

      if (pass) {
        passengerInfos.push(pass);
      }
    }
  }

  return passengerInfos;
};

export const getDraggedPassengersInfo = (
  dragSource: TDragRideDataProcessing,
): IPassengerInfo[] | undefined =>
  dragSource.type === DragTypeEnum.KANBAN_PASSENGER ||
  dragSource.type === DragTypeEnum.GRID_PASSENGER
    ? combineDragPassengers(dragSource.payload)
    : dragSource.payload.rideDto.metadata?.passengersInfo;
